import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import common from './modules/common';

import user from './modules/user';
import cases from './modules/case';
import brand from './modules/brand';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    getters,
    mutations,
    modules: {
        common, user, cases, brand
    },
    actions: actions
});


// WEBPACK FOOTER //
// ./src/store/index.js